{
    "columns":[
		{
			"header_id": "batchFileId",
			"header_label": "File Id",
			"jsonpath":  "batchFileId" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "fileName",
			"header_label": "File Name",
			"jsonpath":  "fileName" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "batchFileTypeLkp",
			"header_label": "File Type",
			"jsonpath":  "batchFileTypeLkp" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "statusDescription",
			"header_label": "File Status",
			"jsonpath":  "statusDescription" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "totalRecords",
			"header_label": "Record Count",
			"jsonpath":  "totalRecords" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		},
		{
			"header_id": "createddate",
			"header_label": "Created Date",
			"jsonpath":  "createddate" ,
			"isDisplayedAtHeader": "y",
			"isSearchable": "y"
		}
    ],
	"buttons": [],
    "apiDetails": "reconFiles.json",
	"pageName": "billingReconFileMasterListView",
	"orderByColumn": ["createddate"],
	"orderBy": ["desc"]
}